const enterprise = (request, api_config) => {
  const prefix = "Enterprise";

  const HeartBeatLogin = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/HeartBeatLogin`,
      method: "post",
      data: data,
    });
    return result;
  };

  const TruelyLogin = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/TruelyLogin`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetUserInfo = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetUserInfo`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetEnterpriseInfo = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetEnterpriseInfo`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetCheckWorkList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetCheckWorkList`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetUserList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetUserList`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetCheckWorkFilters = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetCheckWorkFilters`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetMyStoreListFilters = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetMyStoreListFilters`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetMyStoreList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetMyStoreList`,
      method: "post",
      data: data,
    });
    return result;
  };

  const GetMyStoreCheckWorkFilters = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetMyStoreCheckWorkFilters`,
      method: "get",
      params: data,
    });
    return result;
  };

  const GetMyStoreCheckWorkList = async (data) => {
    const result = await request({
      url: `${api_config}/${prefix}/GetMyStoreCheckWorkList`,
      method: "post",
      data: data,
    });
    return result;
  };

  return {
    HeartBeatLogin,
    TruelyLogin,
    GetUserInfo,
    GetEnterpriseInfo,
    GetCheckWorkList,
    GetUserList,
    GetCheckWorkFilters,
    GetMyStoreListFilters,
    GetMyStoreList,
    GetMyStoreCheckWorkFilters,
    GetMyStoreCheckWorkList,
  };
};

export default enterprise;
